"use strict";
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { Auth } from '../auth/auth.service';
import { ErrorTracking } from '../tracking';
import { ApiHttp } from './api-http.service';
import { ListObservable } from './list-observable';
import { ObjectObservable } from './object-observable';
import { WebSocketService } from './websocket';
var Datastore = (function () {
    function Datastore(store, apiHttp, auth, webSocketService, errorTracking) {
        this.store = store;
        this.apiHttp = apiHttp;
        this.auth = auth;
        this.webSocketService = webSocketService;
        this.errorTracking = errorTracking;
    }
    Datastore.prototype.list = function (arg1) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var optionsQuery = {};
        if (args.length && args[args.length - 1].query) {
            optionsQuery = args.pop().query;
        }
        var args$ = [arg1].concat(args).map(function (key) { return (key instanceof Observable ? key : Observable.of(key)); });
        var pathStream = Observable.combineLatest(args$);
        var queryStream = Observable.combineLatest([
            optionsQuery.limit instanceof Observable
                ? optionsQuery.limit
                : Observable.of(optionsQuery.limit),
            optionsQuery.offset instanceof Observable
                ? optionsQuery.offset
                : Observable.of(optionsQuery.offset),
        ], function (limit, offset) { return ({ limit: limit, offset: offset }); });
        var refStream = Observable.combineLatest([pathStream, queryStream], function (path, query) { return ({ path: path, query: query }); })
            .do(function (ref) {
            var action = {
                type: 'REQUEST_DATA',
                payload: { type: ref.path[0], ref: ref },
            };
            _this.store.dispatch(action);
        })
            .shareReplay(1);
        var fetchStream = this.apiHttp.requestStream
            .withLatestFrom(refStream)
            .filter(function (_a) {
            var fetchReference = _a[0], originalReference = _a[1];
            return fetchReference.path === originalReference.path;
        })
            .map(function (_a) {
            var fetchReference = _a[0], originalReference = _a[1];
            return originalReference;
        });
        var websocketStream = this.webSocketService.fromServerStream.combineLatest(refStream, function (ws, ref) { return ref; });
        return new ListObservable(refStream, this.apiHttp, this.auth, this.store, this.errorTracking, Observable.merge(refStream, fetchStream, websocketStream)
            .switchMap(function (_a) {
            var path = _a.path;
            return (_b = _this.store).pluck.apply(_b, path);
            var _b;
        })
            .combineLatest(queryStream)
            .distinctUntilChanged(function (_a, _b) {
            var prevData = _a[0];
            var currData = _b[0], currQuery = _b[1];
            return prevData === currData ||
                // TODO: handle different lists
                (prevData !== undefined &&
                    currData !== undefined &&
                    !currData.lists.default
                        .slice(currQuery.offset || 0)
                        .some(function (key) {
                        return prevData.entities[key] === undefined ||
                            currData.entities[key] === undefined ||
                            prevData.entities[key].entity !==
                                currData.entities[key].entity;
                    }));
        })
            .map(function (_a) {
            var data = _a[0], query = _a[1];
            if (data && data.lists && data.lists.default) {
                return data.lists.default
                    .slice(query.offset || 0)
                    .map(function (id) { return data.entities[id].entity; });
            }
            return [];
        }));
    };
    Datastore.prototype.object = function (arg1) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var args$ = [arg1].concat(args).map(function (key) { return (key instanceof Observable ? key : Observable.of(key)); });
        var refStream = Observable.combineLatest(args$)
            .map(function (path) { return ({ path: path }); })
            .switchMap(function (_a) {
            var path = _a.path;
            return (_b = _this.store).pluck.apply(_b, path).take(1);
            var _b;
        }, function (ref, data) { return ({ ref: ref, data: data }); })
            .do(function (_a) {
            var ref = _a.ref, data = _a.data;
            // Don't fetch if this was fetched in the last second.
            if (!data || Number(data.timeFetched) + 1000 < Date.now()) {
                var action = {
                    type: 'REQUEST_DATA',
                    payload: { type: ref.path[0], ref: ref },
                };
                _this.store.dispatch(action);
            }
        })
            .map(function (_a) {
            var ref = _a.ref;
            return ref;
        })
            .shareReplay(1);
        var fetchStream = this.apiHttp.requestStream
            .withLatestFrom(refStream)
            .filter(function (_a) {
            var fetchReference = _a[0], originalReference = _a[1];
            return fetchReference.path === originalReference.path;
        })
            .map(function (_a) {
            var fetchReference = _a[0], originalReference = _a[1];
            return originalReference;
        });
        var subscriptionStream = arg1 === 'onlineOffline'
            ? this.webSocketService
                .subscribeOnlineOffline(args$[1])
                .combineLatest(refStream, function (ss, ref) { return ref; })
            : refStream;
        var websocketStream = this.webSocketService.fromServerStream.combineLatest(refStream, function (ws, ref) { return ref; });
        return new ObjectObservable(refStream, this.apiHttp, this.store, Observable.merge(refStream, fetchStream, subscriptionStream, websocketStream)
            .switchMap(function (_a) {
            var path = _a.path;
            return (_b = _this.store).pluck.apply(_b, path);
            var _b;
        })
            .filter(function (obj) { return obj !== undefined; })
            .distinctUntilChanged(function (prev, curr) { return prev.entity === curr.entity; })
            .map(function (obj) { return obj.entity; }));
    };
    Datastore.ctorParameters = function () { return [{ type: Store }, { type: ApiHttp }, { type: Auth }, { type: WebSocketService }, { type: ErrorTracking }]; };
    return Datastore;
}());
export { Datastore };
//# sourceMappingURL=datastore.js.map


// WEBPACK FOOTER //
// datastore.js